<script>
  import {
    CornerDownRightIcon,
  } from 'vue-feather-icons'
  export default {
    components: {
      CornerDownRightIcon,
    },
    props: {
      category: {
        type: null,
        required: true,
      },
      tailwind: {
        type: Boolean,
        default: false,
      },
      semicolon: {
        type: Boolean,
        default: false,
      }
    },
  }
</script>

<template>
  <li
    v-if="tailwind"
    class="tw-flex tw-flex-col md:tw-flex-row md:tw-pb-3 md:tw-justify-between">
    <span v-if="category.level === 3" class="tw-text-black/75 tw-w-full md:tw-w-1/3"><CornerDownRightIcon size="1.2x" class="!tw-inline-flex tw-ml-5 tw-mr-1"/>Tertiary Category{{semicolon ? ':' : ''}}</span>
    <span v-else-if="category.level === 2" class="tw-text-black/75 tw-w-full md:tw-w-1/3"><CornerDownRightIcon size="1.2x" class="!tw-inline-flex tw-mr-1"/>Secondary Category{{semicolon ? ':' : ''}}</span>
    <span v-else class="tw-text-black/75 tw-w-full md:tw-w-1/3">Category{{semicolon ? ':' : ''}}</span>
    <span
      class="
      tw-font-semibold md:tw-text-right
      tw-flex tw-flex-col
      tw-w-full md:tw-w-2/3
      tw-max-w-72 lg:tw-max-w-none
      tw-pl-12 md:tw-pl-0
      tw-pb-2 md:tw-pb-0">
      {{ category.name }}
    </span>
  </li>
  <li
    v-else
    class="item">
    <span v-if="category.level === 3" class="text-label"><CornerDownRightIcon size="1.2x" class="fl-inline ml-4 mr-1"/>Tertiary Category{{semicolon ? ':' : ''}}</span>
    <span v-else-if="category.level === 2" class="text-label"><CornerDownRightIcon size="1.2x" class="fl-inline mr-1"/>Secondary Category{{semicolon ? ':' : ''}}</span>
    <span v-else class="text-label">Category{{semicolon ? ':' : ''}}</span>
    <span class="text-value text-bold">
      {{ category.name }}
    </span>
  </li>
</template>
